import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaCheckCircle } from 'react-icons/fa'; // Import FontAwesome check-circle icon
import { Spinner } from 'react-bootstrap'; // Import Bootstrap Spinner for loader
import {postMethod} from "../Helpers/services"
import {get_ifsccodes_data} from "../Enums/api_constunts"
import _ from "lodash";
const IFSCCodeVerification = ({onChange}) => {
  const [ifscCode, setIfscCode] = useState('');
  const [isValid, setIsValid] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // State for loader visibility
  const [selectedIfscCode,setselectedIfscCode] = useState("")
  const [isTouched, setIsTouched] = useState(false);
  const verifyIFSCCode = async () => {
    setIsLoading(true);
    let post_data = {
      "search_string":ifscCode,
      "page": 1,
      "per_page":1
    };
    postMethod(get_ifsccodes_data,post_data).then((res)=>{
      setIsValid(true); // Valid IFSC code
      setselectedIfscCode(_.get(res,"result"))
      
      onChange({"ifscCode":ifscCode,"isValied":true});
      setIsLoading(false);
    }).catch ((error)=>{
      setselectedIfscCode(null)
      onChange({"ifscCode":ifscCode,"isValied":true});
      setIsValid(false);
      setIsLoading(false);

    })

  };


const [debounce, setdebounce] = useState(null)
  useEffect(()=>{
   clearTimeout(debounce)
    setdebounce( setTimeout(() => {
      verifyIFSCCode()
    }, 500)
   )
      
  
  
  return ()=>{
    clearTimeout(debounce)
  }
   
  },[ifscCode]);
  return (
    
    <>
        <div className="col-md-4 mb-2 mt-2">
          <div className="form-group">
            <label htmlFor="ifscCode">Enter IFSC Code</label>
            <div className="input-group">
              <input
                type="text"
                id="ifscCode"
                className={`form-control ${isTouched && (isValid === false) && ifscCode!=="" ? 'is-invalid' : ''}`}
                value={ifscCode}
                onBlur={() => setIsTouched(true)}
                onChange={(e) => {
                  setIsTouched(true);
                  setIfscCode(e.target.value);
                  
                  
                }}
                placeholder="Enter IFSC code"
              />
              <div className="input-group-append">
                <button
                  className="btn btn-primary"
                  onClick={verifyIFSCCode}
                  disabled={isLoading} // Disable button while loading
                >
                  {isLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    'Verify'
                  )}
                </button>
              </div>
              {/* Display Green Tick if valid */}
              {isValid === true && (
                <div className="input-group-text" style={{ color: 'green', background: 'transparent', border: 'none' }}>
                  <FaCheckCircle />
                </div>
              )}
            </div>
          
            {!isValid  && (
              <div className="invalid-feedback">Invalid IFSC Code</div>
            )}
            {isValid  && (
              <div className="valid-feedback">
                <span className="text-success">✔️ Valid IFSC Code</span>
              </div>
            )}
          </div>
        </div>
        {_.get(selectedIfscCode,"IFSC")&&<div className="col-md-8 mb-2 mt-8">
               <span>
                {_.get(selectedIfscCode,"BANK","") &&<>Bank : {_.get(selectedIfscCode,"BANK")}<br></br></>}
                {_.get(selectedIfscCode,"CITY1","") &&<>City : {_.get(selectedIfscCode,"CITY1")} <br></br></>}
                {_.get(selectedIfscCode,"STATE","")&& <>State : {_.get(selectedIfscCode,"STATE")}<br></br></>}
                {_.get(selectedIfscCode,"ADDRESS","")&&<>Address : {_.get(selectedIfscCode,"ADDRESS")}</>}
              </span>
              
        </div>
        }
        </>
      
  );
};

export default IFSCCodeVerification;
